export function Bus() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="42"
      viewBox="0 0 36 42"
      fill="none"
    >
      <path
        d="M17.7864 0.339844C8.19246 0.339844 0.421875 1.42516 0.421875 9.02206V30.7277C0.421875 32.6486 1.26839 34.3525 2.5924 35.5463V39.41C2.5924 40.6038 3.56916 41.5805 4.76293 41.5805H6.93356C8.13823 41.5805 9.10409 40.6038 9.10409 39.41V37.2394H26.4686V39.41C26.4686 40.6038 27.4345 41.5805 28.6392 41.5805H30.8097C32.0035 41.5805 32.9802 40.6038 32.9802 39.41V35.5464C34.3042 34.3526 35.1507 32.6487 35.1507 30.7278V9.02206C35.1508 1.42516 27.3803 0.339844 17.7864 0.339844ZM8.01888 32.8983C6.21728 32.8983 4.76303 31.444 4.76303 29.6424C4.76303 27.8408 6.21728 26.3866 8.01888 26.3866C9.82048 26.3866 11.2747 27.8408 11.2747 29.6424C11.2747 31.444 9.82038 32.8983 8.01888 32.8983ZM27.5539 32.8983C25.7523 32.8983 24.2981 31.444 24.2981 29.6424C24.2981 27.8408 25.7523 26.3866 27.5539 26.3866C29.3555 26.3866 30.8098 27.8408 30.8098 29.6424C30.8098 31.444 29.3554 32.8983 27.5539 32.8983ZM30.8098 19.8749H4.76303V9.02206H30.8098V19.8749Z"
        fill="#5B5B5B"
      />
    </svg>
  )
}
